class MessageParser {
  constructor(actionProvider, state) {
    this.actionProvider = actionProvider;
    this.state = state;
  }

  parse(message) {
    if (message) {
      this.actionProvider.handleSendMessage(message, this.state);
    }
  }
}

export default MessageParser;
